const postingDatePolicy = {
  PostingDatePolicy: "Posting Date Policy",
  posting_date_policy: "Posting Date Policy",
  posting_date_policies: "Posting Date Policies",
  add_posting_date_policy: "Add Posting Date Policy",
  edit_posting_date_policy: "Edit Posting Date Policy",
  name: "Name",
  cut_off_day: "Cutoff Day",
  status: "Status",
  actions: "Actions",
  active: "Active",
  inactive: "Inactive",
  activate: "Activate",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  add: "Add",
  update: "Update",
  something_went_wrong: "Something went wrong",
  no_posting_date_policies_found: "No posting date policies found",
  posting_date_policy_rules_column: "Posting Date Rules",
  posting_date_policy_same_month_before_rule:
    "Reviewed in Same Month (On/Before Cutoff Day)",
  posting_date_policy_same_month_after_rule:
    "Reviewed in Same Month (After Cutoff Day)",
  posting_date_policy_early_rule: "Reviewed Prior Month (On/Before Cutoff Day)",
  posting_date_policy_late_rule: "Reviewed Prior Month (After Cutoff Day)",
  posting_date_policy_same_month_before_label: "Same month, on/before {{day}}",
  posting_date_policy_same_month_after_label: "Same month, after {{day}}",
  posting_date_policy_prior_month_on_before_label:
    "Prior month, on/before {{day}}",
  posting_date_policy_prior_month_after_label: "Prior month, after {{day}}",
  posting_date_policy_name_hint:
    "Give this policy a clear name and set the cutoff day.",
  posting_date_policy_cutoff_day_hint:
    "Defines the boundary for invoices (1–31).",
  posting_date_policy_same_month_section_title: "Same-month rules",
  posting_date_policy_same_month_section_subtitle:
    "Applies when the invoice belongs to the same month as the review month — driven by the cutoff day above.",
  posting_date_policy_prior_month_section_title: "Prior-month rules",
  posting_date_policy_prior_month_section_subtitle:
    "Applies when the invoice belongs to a month before the review month — driven by the cutoff day above.",
  posting_date_type_review_date: "Review / Integration Date",
  posting_date_type_invoice_date: "Invoice Date",
  posting_date_type_last_day_of_invoice_month: "Last Day of Invoice Month",
  posting_date_type_first_day_of_review_month: "First Day of Review Month",
  posting_date_type_last_day_of_review_month:
    "Last Day of Previous Month (from Review Date)",
  posting_date_type_day_after_cuttoff_review_month:
    "Day After Cut-Off (Review Month)",
  posting_date_type_first_day_of_previous_review_month:
    "First Day of Previous Month (from Review Date)",
  posting_date_policy_name_required: "Name is required",
  posting_date_policy_cutoff_days_required: "Cutoff day is required",
  posting_date_policy_cutoff_days_range: "Cutoff day must be between 1 and 31",
  posting_date_policy_rule_required: "This rule is required",
  posting_date_policy_created_successfully:
    "Posting date policy created successfully",
  posting_date_policy_updated_successfully:
    "Posting date policy updated successfully",
  posting_date_policy_deleted_successfully:
    "Posting date policy deleted successfully",
  posting_date_policy_activated_successfully:
    "Posting date policy activated successfully",
  cannot_delete_active_posting_date_policy:
    "The active posting date policy cannot be deleted, deactivate it to delete",
  posting_date_policy_deactivated_successfully:
    "Posting date policy deactivated successfully",
  delete_posting_date_policy_title: "Delete Posting Date Policy",
  delete_posting_date_policy_description:
    "Are you sure you want to delete this posting date policy?",
};

export default postingDatePolicy;
